import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService, ConfigStateService, PermissionService, RoutesService } from '@abp/ng.core';
import { APP_ROUTE_NAMES } from '../../app/route.provider';

export const firstAllowedRouteGuard: CanActivateFn = () => {
  const router = inject(Router);
  const authService = inject(AuthService);
  const routesService = inject(RoutesService);
  const permissionService = inject(PermissionService);
  const configState = inject(ConfigStateService);

  if (!authService.isAuthenticated) {
    authService.navigateToLogin();
    return false;
  }

  const tenantId = configState.getDeep('currentUser.tenantId');
  if (tenantId === null || tenantId === undefined) {
    return router.createUrlTree(['/saas/tenants']);
  }

  const appRoutes = routesService.flat
    .filter(r => (APP_ROUTE_NAMES as readonly string[]).includes(r.name))
    .sort((a, b) => (a.order ?? 0) - (b.order ?? 0));

  for (const route of appRoutes) {
    if (
      route.path &&
      (!route.requiredPolicy || permissionService.getGrantedPolicy(route.requiredPolicy))
    ) {
      return router.createUrlTree([route.path]);
    }
  }

  return router.createUrlTree(['/no-access']);
};
